import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { authoringRoute } from "../authoring.runtime"
import { Secure } from "lib/authorization/secure"
import { ArchivedWorkPackagesPage } from "../home/plugins/archived-work-packages/archived-work-packages-page"
import {
    AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND,
    AUTHORING_VIEW_ARCHIVED_WORK_PACKAGES_DEMAND,
} from "authoring/lib/constants/authoring-permissions.mjs"
import { Project } from "./project"
import { ProjectList } from "./project-list"
import Iconify from "minimals-template/components/Iconify"
import "./feature-flag-authoring-publish"
import "./feature-flag-global-updates"
import "./feature-flag-archive-work-packages"
import { ProjectUsers } from "authoring/routes/project/components/user-access/project-users"
import { ComponentSimilarityPanel } from "./group/overwrite/task-correlator/component-similarity-panel"
import { useParams } from "react-router"
import { ProjectBoundary } from "../../lib/authorization/scoped-boundaries"
import { Group } from "./group/group"
import { AddTask } from "./group/task-editor/add-task"
import { GroupRouteBoundary } from "./group/group-route-boundary"
import "authoring/routes/pdf/pdf.runtime"

authoringRoute.register("projects", <ProjectList $lazy />)
authoringRoute.register(
    "projects/archive",
    <Secure demand={[AUTHORING_VIEW_ARCHIVED_WORK_PACKAGES_DEMAND, AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND]} and={false}>
        <ArchivedWorkPackagesPage $lazy />
    </Secure>
)

export function withProjectBoundary(Component) {
    return function WrappedComponent(props) {
        const { projectId } = useParams()
        return (
            <ProjectBoundary id={projectId}>
                <Component {...props} />
            </ProjectBoundary>
        )
    }
}

const ProjectWithBoundary = withProjectBoundary(Project)

const ProjectUsersWithBoundary = withProjectBoundary(ProjectUsers)
const ComponentSimilarityPanelWithBoundary = withProjectBoundary(ComponentSimilarityPanel)
const GroupWithBoundary = withProjectBoundary(Group)
const AddTaskWithBoundary = withProjectBoundary(AddTask)

function withProjectGroupBoundary(Component) {
    return function WrappedComponent(props) {
        return (
            <GroupRouteBoundary>
                <Component {...props} />
            </GroupRouteBoundary>
        )
    }
}

const ComponentSimilarityPanelWithGroupBoundary = withProjectGroupBoundary(ComponentSimilarityPanelWithBoundary)
const GroupWithGroupBoundary = withProjectGroupBoundary(GroupWithBoundary)
const AddTaskWithGroupBoundary = withProjectGroupBoundary(AddTaskWithBoundary)

authoringRoute.register("projects/:projectId", <ProjectWithBoundary $lazy />)

authoringRoute.register("projects/:projectId/users", <ProjectUsersWithBoundary $lazy />)
authoringRoute.register("projects/:projectId/:groupId", <GroupWithGroupBoundary $lazy />)

authoringRoute.register(
    "projects/:projectId/:groupId/component-similar/:componentId/:componentVersion",
    <ComponentSimilarityPanelWithGroupBoundary $lazy />
)

authoringRoute.register("projects/:projectId/:groupId/add-task", <AddTaskWithGroupBoundary $lazy />)

registerConditionalPageNavigation(
    () => true,
    "/authoring/projects",
    "Work Packages",
    <Iconify icon="mdi:clipboard-text-outline" />,
    {
        group: "Work Packages",
        subPaths: true,
    }
)
